import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/common/components/ui/dialog';
import { useAuth } from '../useAuth';
import { NameCaptureForm } from './NameCaptureForm';
import { useUpdateMyName } from './useUpdateMyName';

interface ProfileNameDialogProps {
  onClose: () => void;
}

/** Name editing for surfaces with no settings area of their own, which is the
 *  whole job portal. Not worth inventing a settings page for two fields. */
export const ProfileNameDialog: React.FC<ProfileNameDialogProps> = ({ onClose }) => {
  const { user } = useAuth();
  const updateName = useUpdateMyName({
    surface: 'settings',
    prefilled: {
      first: user?.first_name ?? '',
      last: user?.last_name ?? '',
      source: 'idp',
    },
    onSaved: onClose,
  });

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="bg-white max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-foreground">Your name</DialogTitle>
        </DialogHeader>
        <NameCaptureForm
          initialFirstName={user?.first_name ?? ''}
          initialLastName={user?.last_name ?? ''}
          suggestionSource="idp"
          variant="settings"
          isSaving={updateName.isPending}
          error={updateName.isError ? 'Could not save your name. Please try again.' : null}
          allowSkip={false}
          onSubmit={(firstName, lastName) =>
            updateName.mutate({ body: { first_name: firstName, last_name: lastName } })
          }
        />
      </DialogContent>
    </Dialog>
  );
};

export default ProfileNameDialog;
